import { render } from "./QuestionsSlug.vue?vue&type=template&id=796ae63e"
import script from "./QuestionsSlug.vue?vue&type=script&lang=js"
export * from "./QuestionsSlug.vue?vue&type=script&lang=js"

import "./QuestionsSlug.vue?vue&type=style&index=0&id=796ae63e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__